
define('text!templates/filter_list_search.html',[],function () { return '<div class="search">\n  <input class="txt" type="text" autocomplete="off" placeholder="Search"/>\n</div>\n';});

